import { useState, useEffect } from "react";
const BASE = "https://imalishawelfare.com/api";

export default function Settings({ adminData }) {
  const [tab, setTab] = useState("loan");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [newAdmin, setNewAdmin] = useState({ email:"", fullName:"", password:"" });
  const [admins, setAdmins] = useState([]);
  const [loanSettings, setLoanSettings] = useState({ minAmount:10000, maxAmount:50000, feePercent:15, elderlyMin:15000, elderlyMax:50000, disabilityMin:10000, disabilityMax:45000, vulnerableMin:10000, vulnerableMax:35000 });
  const [logs, setLogs] = useState([]);

  const token = () => sessionStorage.getItem("token");

  useEffect(()=>{
    if (tab==="admins") loadAdmins();
    if (tab==="logs") loadLogs();
  }, [tab]);

  const loadAdmins = async () => {
    try {
      const r = await fetch(`${BASE}/admin/admins`, { headers:{ "Authorization":"Bearer "+token() } });
      if (r.ok) setAdmins(await r.json());
    } catch(e) {}
  };

  const loadLogs = async () => {
    try {
      const r = await fetch(`${BASE}/admin/logs`, { headers:{ "Authorization":"Bearer "+token() } });
      if (r.ok) setLogs(await r.json());
      else setLogs([{ timestamp:new Date().toISOString(), action:"System started", user:"System" }]);
    } catch(e) { setLogs([{ timestamp:new Date().toISOString(), action:"Logs not available", user:"�" }]); }
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      await fetch(`${BASE}/admin/settings/loan`, { method:"PUT", headers:{ "Authorization":"Bearer "+token(), "Content-Type":"application/json" }, body:JSON.stringify(loanSettings) });
    } catch(e) {}
    setSaved(true);
    setTimeout(()=>setSaved(false), 3000);
    setSaving(false);
  };

  const createAdmin = async () => {
    if (!newAdmin.email||!newAdmin.fullName||!newAdmin.password) { alert("Fill all fields"); return; }
    try {
      const r = await fetch(`${BASE}/admin/create-admin`, { method:"POST", headers:{ "Authorization":"Bearer "+token(), "Content-Type":"application/json" }, body:JSON.stringify(newAdmin) });
      if (r.ok) { alert("Admin created!"); setNewAdmin({ email:"", fullName:"", password:"" }); loadAdmins(); }
      else alert("Failed to create admin");
    } catch(e) { alert("Error: "+e.message); }
  };

  const TABS = [["loan","Loan Settings"],["admins","Admin Users"],["system","System"],["logs","Activity Logs"]];
  const inp = { width:"100%", padding:"10px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:13, boxSizing:"border-box" };

  return (
    <div>
      <div style={{ display:"flex", gap:8, marginBottom:20, flexWrap:"wrap" }}>
        {TABS.map(([id,lbl])=>(
          <button key={id} onClick={()=>setTab(id)} style={{ padding:"8px 20px", borderRadius:8, border:"none", cursor:"pointer", fontSize:13, fontWeight:600, background:tab===id?"#0066cc":"white", color:tab===id?"white":"#64748b", boxShadow:"0 1px 4px rgba(0,0,0,0.08)" }}>{lbl}</button>
        ))}
      </div>

      {tab==="loan" && (
        <div style={{ background:"white", borderRadius:12, padding:"24px 28px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
          <h3 style={{ fontSize:16, fontWeight:800, margin:"0 0 20px", color:"#1e293b" }}>Loan Amount Settings</h3>
          <div style={{ background:"#fff8e6", border:"1px solid #f59e0b", borderRadius:8, padding:"10px 14px", marginBottom:20, fontSize:13, color:"#92400e" }}>
            Changes here update the loan offer ranges sent to applicants upon approval.
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:18, marginBottom:24 }}>
            <div>
              <label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase" }}>Global Min Amount (KSh)</label>
              <input style={inp} type="number" value={loanSettings.minAmount} onChange={e=>setLoanSettings(p=>({...p,minAmount:e.target.value}))}/>
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase" }}>Global Max Amount (KSh)</label>
              <input style={inp} type="number" value={loanSettings.maxAmount} onChange={e=>setLoanSettings(p=>({...p,maxAmount:e.target.value}))}/>
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase" }}>Processing Fee %</label>
              <input style={inp} type="number" value={loanSettings.feePercent} onChange={e=>setLoanSettings(p=>({...p,feePercent:e.target.value}))}/>
            </div>
          </div>

          <h4 style={{ fontSize:14, fontWeight:700, margin:"0 0 16px", color:"#1e293b" }}>Category-Specific Ranges</h4>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:16, marginBottom:24 }}>
            {[["Elderly Persons (65+)","elderlyMin","elderlyMax","#0066cc"],["Persons with Disabilities","disabilityMin","disabilityMax","#7c3aed"],["Vulnerable Families","vulnerableMin","vulnerableMax","#10b981"]].map(([lbl,minK,maxK,color])=>(
              <div key={lbl} style={{ background:"#f8fafc", borderRadius:10, padding:"16px", border:"1px solid #e2e8f0" }}>
                <div style={{ fontWeight:700, fontSize:13, color, marginBottom:12 }}>{lbl}</div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                  <div>
                    <label style={{ fontSize:11, color:"#64748b", fontWeight:600, display:"block", marginBottom:4 }}>Min (KSh)</label>
                    <input style={{ ...inp }} type="number" value={loanSettings[minK]} onChange={e=>setLoanSettings(p=>({...p,[minK]:e.target.value}))}/>
                  </div>
                  <div>
                    <label style={{ fontSize:11, color:"#64748b", fontWeight:600, display:"block", marginBottom:4 }}>Max (KSh)</label>
                    <input style={{ ...inp }} type="number" value={loanSettings[maxK]} onChange={e=>setLoanSettings(p=>({...p,[maxK]:e.target.value}))}/>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button onClick={saveSettings} disabled={saving} style={{ padding:"11px 28px", background:"linear-gradient(135deg,#0066cc,#0052a3)", color:"white", border:"none", borderRadius:8, fontWeight:700, fontSize:14, cursor:"pointer" }}>
            {saving?"Saving...":saved?"Saved!":"Save Settings"}
          </button>
          {saved && <span style={{ marginLeft:12, color:"#10b981", fontWeight:600, fontSize:13 }}>Settings saved successfully!</span>}
        </div>
      )}

      {tab==="admins" && (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 360px", gap:20 }}>
          <div style={{ background:"white", borderRadius:12, padding:"24px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
            <h3 style={{ fontSize:16, fontWeight:800, margin:"0 0 18px", color:"#1e293b" }}>Admin Users</h3>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead><tr style={{ background:"#f8fafc" }}>
                {["Name","Email","Role","Actions"].map(h=><th key={h} style={{ padding:"10px 14px", textAlign:"left", fontWeight:700, color:"#64748b", fontSize:11, textTransform:"uppercase" }}>{h}</th>)}
              </tr></thead>
              <tbody>
                {admins.length===0 && <tr><td colSpan={4} style={{ padding:32, textAlign:"center", color:"#94a3b8" }}>Loading admins...</td></tr>}
                {admins.map(a=>(
                  <tr key={a.id} style={{ borderTop:"1px solid #f1f5f9" }}>
                    <td style={{ padding:"12px 14px", fontWeight:600 }}>{a.fullName}</td>
                    <td style={{ padding:"12px 14px", color:"#64748b" }}>{a.email}</td>
                    <td style={{ padding:"12px 14px" }}><span style={{ background:"#eff6ff", color:"#0066cc", borderRadius:20, padding:"3px 10px", fontSize:11, fontWeight:700 }}>{a.role}</span></td>
                    <td style={{ padding:"12px 14px" }}>
                      {a.email !== adminData?.email && <button style={{ padding:"4px 12px", background:"#fee2e2", color:"#dc2626", border:"none", borderRadius:6, fontSize:11, fontWeight:600, cursor:"pointer" }}>Remove</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ background:"white", borderRadius:12, padding:"24px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
            <h3 style={{ fontSize:16, fontWeight:800, margin:"0 0 18px", color:"#1e293b" }}>Add New Admin</h3>
            <div style={{ display:"grid", gap:14 }}>
              <div><label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase" }}>Full Name</label><input style={inp} value={newAdmin.fullName} onChange={e=>setNewAdmin(p=>({...p,fullName:e.target.value}))} placeholder="Admin full name"/></div>
              <div><label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase" }}>Email</label><input style={inp} type="email" value={newAdmin.email} onChange={e=>setNewAdmin(p=>({...p,email:e.target.value}))} placeholder="admin@email.com"/></div>
              <div><label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase" }}>Password</label><input style={inp} type="password" value={newAdmin.password} onChange={e=>setNewAdmin(p=>({...p,password:e.target.value}))} placeholder="Strong password"/></div>
              <button onClick={createAdmin} style={{ padding:"11px", background:"linear-gradient(135deg,#0066cc,#0052a3)", color:"white", border:"none", borderRadius:8, fontWeight:700, fontSize:14, cursor:"pointer" }}>Create Admin Account</button>
            </div>
          </div>
        </div>
      )}

      {tab==="system" && (
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:20 }}>
          {[["Database Backup","Export all data to SQL backup file","#0066cc","Backup Now"],["Clear Cache","Clear system cache and temp files","#f59e0b","Clear Cache"],["System Health","Check all system components","#10b981","Run Check"],["Maintenance Mode","Take site offline for maintenance","#ef4444","Toggle Mode"]].map(([title,desc,color,action])=>(
            <div key={title} style={{ background:"white", borderRadius:12, padding:"24px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
              <div style={{ width:44, height:44, background:color+"15", borderRadius:10, marginBottom:14, display:"flex", alignItems:"center", justifyContent:"center" }}>
                <div style={{ width:22, height:22, background:color, borderRadius:6 }}/>
              </div>
              <h3 style={{ fontSize:15, fontWeight:700, margin:"0 0 6px", color:"#1e293b" }}>{title}</h3>
              <p style={{ fontSize:13, color:"#64748b", margin:"0 0 18px", lineHeight:1.6 }}>{desc}</p>
              <button style={{ padding:"9px 20px", background:color, color:"white", border:"none", borderRadius:8, fontWeight:600, fontSize:13, cursor:"pointer" }}>{action}</button>
            </div>
          ))}
          <div style={{ background:"white", borderRadius:12, padding:"24px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)", gridColumn:"span 2" }}>
            <h3 style={{ fontSize:15, fontWeight:700, margin:"0 0 16px", color:"#1e293b" }}>System Information</h3>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:12 }}>
              {[["Domain","imalishawelfare.com"],["Server IP","89.117.37.139"],["Backend Port","8090"],["Database","MySQL 8.4"],["SSL","Let's Encrypt (Active)"],["Backend","Spring Boot 3.2.0"],["Frontend","React 18"],["Admin Email","admin@imalishawelfare.com"]].map(([k,v])=>(
                <div key={k} style={{ background:"#f8fafc", borderRadius:8, padding:"10px 14px", border:"1px solid #e2e8f0" }}>
                  <p style={{ fontSize:11, color:"#94a3b8", fontWeight:600, margin:"0 0 3px", textTransform:"uppercase" }}>{k}</p>
                  <p style={{ fontSize:13, fontWeight:600, margin:0, color:"#1e293b" }}>{v}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {tab==="logs" && (
        <div style={{ background:"white", borderRadius:12, padding:"24px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
            <h3 style={{ fontSize:16, fontWeight:800, margin:0, color:"#1e293b" }}>Activity Logs</h3>
            <button onClick={loadLogs} style={{ padding:"7px 16px", background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:8, fontSize:12, fontWeight:600, cursor:"pointer" }}>Refresh</button>
          </div>
          <div style={{ display:"grid", gap:8 }}>
            {logs.map((l,i)=>(
              <div key={i} style={{ display:"flex", gap:16, padding:"12px 16px", background:"#f8fafc", borderRadius:8, border:"1px solid #e2e8f0", fontSize:13 }}>
                <span style={{ color:"#94a3b8", flexShrink:0, fontFamily:"monospace" }}>{l.timestamp?.split("T")[0]} {l.timestamp?.split("T")[1]?.split(".")[0]}</span>
                <span style={{ flex:1, color:"#1e293b" }}>{l.action}</span>
                <span style={{ color:"#0066cc", fontWeight:600 }}>{l.user}</span>
              </div>
            ))}
            {logs.length===0 && <p style={{ textAlign:"center", color:"#94a3b8", padding:32 }}>No logs available</p>}
          </div>
        </div>
      )}
    </div>
  );
}



